import { render, staticRenderFns } from "./NewTasks.vue?vue&type=template&id=989d2296&"
import script from "./NewTasks.vue?vue&type=script&lang=ts&"
export * from "./NewTasks.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports